<div class="container">  
    
    <br>  
    <div class="row">  
        <div class="col-md-6">  
            <input class="form-control" type="file" #fileInput />  
        </div>  
        <div class="col-md-6">  
            <button class="btn btn-primary" (click)="uploadFile();">Upload</button>  
        </div>  
    </div>  
</div>
